import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-23b1c34e")
const _hoisted_1 = { class: "plant-plastic-source-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 506@2x.png",
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "farming-records" }
const _hoisted_4 = { class: "line1" }
const _hoisted_5 = { class: "medi-font" }
const _hoisted_6 = { class: "line2 litt-font" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "line2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", { class: "icons" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-shipinti1beifen3-copy" })
], -1)
const _hoisted_13 = {
  key: 0,
  class: "line4"
}
const _hoisted_14 = { class: "div" }
const _hoisted_15 = {
  key: 1,
  class: "line5"
}
const _hoisted_16 = { class: "img-right" }
const _hoisted_17 = {
  key: 2,
  class: "count-img-num"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingRecordList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "reco",
        key: item.id
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.optionDate?item.optionDate.split(" ")[0]:""), 1),
            _withDirectives(_createElementVNode("span", { class: "medi-font" }, "#" + _toDisplayString(item.areaCode) + "地块", 513), [
              [_vShow, item.areaCode]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (item.area)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "完成" + _toDisplayString(item.area) + "亩 ", 1))
              : _createCommentVNode("", true),
            (item.artificial)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "投入" + _toDisplayString(item.artificial) + "个人工", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(item.remark), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.videos, (i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line3",
              key: i
            }, [
              _createElementVNode("div", {
                class: "video-poster",
                onClick: ($event: any) => (_ctx.onPreviewVideo(i.url))
              }, [
                _createElementVNode("img", {
                  src: i.url + _ctx.getVideoPoster()
                }, null, 8, _hoisted_11),
                _hoisted_12
              ], 8, _hoisted_10)
            ]))
          }), 128)),
          (item.videos.length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (items, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "img-wrap",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_van_image, {
                        class: "imgs",
                        radius: "0.625rem",
                        fit: "cover",
                        src: items.url + '?imageView2/2',
                        onClick: ($event: any) => (_ctx.onPreviewImg(index, item.images))
                      }, null, 8, ["src", "onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (item.videos.length == 0&&item.images.length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_van_image, {
                  class: _normalizeClass(item.images.length != 0&&item.images.length > 1?'more-img':'only-img'),
                  onClick: ($event: any) => (_ctx.onPreviewImg(0, item.images)),
                  fit: "cover",
                  radius: "0.25rem",
                  src: item.images[0].url+ '?imageView2/2'
                }, null, 8, ["class", "onClick", "src"]),
                _createElementVNode("div", _hoisted_16, [
                  (item.images[1])
                    ? (_openBlock(), _createBlock(_component_van_image, {
                        key: 0,
                        class: "l5-img",
                        onClick: ($event: any) => (_ctx.onPreviewImg(1, item.images)),
                        fit: "cover",
                        radius: "0.25rem",
                        src: item.images[1].url+ '?imageView2/2'
                      }, null, 8, ["onClick", "src"]))
                    : _createCommentVNode("", true),
                  (item.images[2])
                    ? (_openBlock(), _createBlock(_component_van_image, {
                        key: 1,
                        class: "l5-img",
                        onClick: ($event: any) => (_ctx.onPreviewImg(2, item.images)),
                        fit: "cover",
                        radius: "0.25rem",
                        src: item.images[2].url+ '?imageView2/2'
                      }, null, 8, ["onClick", "src"]))
                    : _createCommentVNode("", true),
                  (item.images.length > 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.images.length) + "图", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode(_component_preview_video, {
      visible: _ctx.showVideos,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVideos = $event)),
      autoplay: "",
      url: _ctx.videoUrl
    }, null, 8, ["visible", "url"])
  ]))
}